import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";

import ContextComponent from "../../../AppContext";
import Utils from "../../../Utils";
import DataTable from "../../../controls/table/DataTable";
import AddIcon from "../../../../assets/img/add.png";
import EditIcon from "../../../../assets/img/Edit.png";
import DeleteIcon from "../../../../assets/img/Delete.png";
import EmptyPage from "../../../pages/EmptyPage";

import CloneSitePage from "./site/CloneSitePage";
import MoveSitePage from "./site/MoveSitePage";
import { ArrowsMove } from "react-bootstrap-icons";


const Sitespage = () => {
    let [admin, setAdmin] = useState(false);
    let [superAdmin, setSuperAdmin] = useState(false);

    let { userData } = useContext(ContextComponent);
     let folderPath = useParams();

    useEffect(() => {
        setAdmin(!!userData?.admin);
        setSuperAdmin(!!userData?.superAdmin);
    }, [admin, superAdmin, userData]);


    let [showDeleteModal, setShowDeleteModal] = useState(false);
    let [selectedItemCount, setSelectedItemCount] = useState(0);
    const DISABLED_ICON = Utils.APP_CLASS_NAMES.disableStyle;
    let [editIconClass, setEditIconClass] = useState(DISABLED_ICON);
    let [moveIconClass, setMoveIconClass] = useState(DISABLED_ICON);
    let [tableSelectedItems, setTableSelectedItems] = useState([]);
    let [siteIdForEdit, setSiteIdForEdit] = useState("");
    let [allSites, setAllSites] = useState([]);
    let navigate = useNavigate();

    useEffect(() => {
        if (tableSelectedItems.length === 1) {
            setEditIconClass("");
            setSiteIdForEdit(tableSelectedItems[0]);
        } else {
            setEditIconClass(DISABLED_ICON);
            setSiteIdForEdit("");
        }
        if (tableSelectedItems.length >= 1) {
          setMoveIconClass("");
        } else {
          setMoveIconClass(DISABLED_ICON);
        }
    }, [tableSelectedItems]);

    let { setCanRedirectToLogin, setLoadingState, setAlert,  folderStructure } =
        useContext(ContextComponent);

    let [tableColumns, setTableColumns] = useState([
        "id",
        "select",
        "name",
        "description",
        "classicview",
    ]);
    let localObj = "this is local obj";
    let [tableColumnSchema, setTableColumnSchema] = useState({
        id: {
            type: "hidden",
            title: "id",
        },
        select: {
            type: "checkbox",
            title: "-",
            center: true,
        },
        name: {
            type: "link",
            search: true,
            sort: false,
            title: "Name",
            handleLink: (obj) => {
                navigate(Utils.APP_URLS.SITE_PAGE.replace(":siteid", obj.id));
            }
        },
        description: {
            type: "text",
            search: true,
            sort: false,
            title: "Description",
        },
        classicview: {
            type: "boolean",
            search: false,
            sort: false,
            title: "New Interface",
        },
    });

    let [tableData, setTableData] = useState([]);
    let [canRender, setCanRender] = useState(false);
    let [renderDataTable, setRenderDataTable] = useState(false);
    let [renderEmptyPage, setRenderEmptyPage] = useState(false);
    let [updateTable, setUpdateTable] = useState(false);
    let [siteContent, setSiteContent] = useState([]);
    let [projectid, setProjectid] = useState(null);

    const updateTableData = (data) => {
        setAllSites(data);
        let siteInfo = data;
        let sitesArray = [];
        if (!Utils.isObjectEmpty(siteInfo)) {
            sitesArray = siteInfo.map((siteData, index) => {
                let siteTableObj = [];
                let siteTableData = [];
                tableColumns.forEach((col) => {
                    if (col === "select") {
                        siteTableData.push(false);
                    } else if (col === "classicview") {
                        // let isSuperAdmin = siteInfo[index]['superAdmin'];
                        // let valueToBePush = isSuperAdmin ? Utils.APP_CONSTANTS.DOUBLE_TICK : siteInfo[index][col];
                        let valueToBePush = siteInfo?.[index]?.['classicview'] || false;
                        siteTableData.push(valueToBePush);
                    } else {
                        siteTableData.push(siteInfo[index][col]);
                    }
                });
                siteTableObj = siteTableData;
                return siteTableObj;
            });

            setTableData(sitesArray);
            setSiteContent(siteInfo);
            setCanRender(true);
        }
    };

    const success = (res) => {
        setLoadingState({
            applyMask: false,
        });
       let data = res.data.sort((itemA, itemB) => {
            return itemA.name.localeCompare(itemB.name);
        });
        if (data.length > 0) {
          updateTableData(data);
          setRenderDataTable(true);
          setRenderEmptyPage(false);
        } else {
          setRenderEmptyPage(true);
          setRenderDataTable(false);
          setCanRender(true);
        }
        setLoadingState({ applyMask: false });
        setTableSelectedItems([]);
    };

    const fail = (err) => {
        setLoadingState({
            applyMask: false,
        });
        err?.message?.length && console.log(err);
        if (err?.redirect) {
            setCanRedirectToLogin(true);
        }
    };

    const loadFreshSites = () => {
        Utils.getAllSites().then(success, fail);
    };

    useEffect(() => {
        setLoadingState({
            applyMask: true,
            text: "Loading sites",
        });
        loadFreshSites();
    }, []);

    useEffect(() => {
        if (tableData.length) {
            // console.log("table has data now");
        }
    }, [tableData]);

    //to get the projectid from the folder structure
      useEffect(() => {
        if (folderStructure?.length && folderPath["*"] !== undefined) {
          const trimmedPath = folderPath["*"].replace("internal/project", "");
          const currentPath = "/" + trimmedPath.replace(/^\/+/, "");
          let match;
    
          if (currentPath === "/" || currentPath === "") {
            // Handle root case explicitly
            match = folderStructure.find((item) => item.path === "/Root");
          } else {
            match = folderStructure.find((item) => item.path === currentPath);
          }
          if (match) {
            setProjectid(match?.id);
          } else {
            setProjectid(null);
          }
        }
      }, [folderStructure, folderPath]);

    const handleShow = async (e) => {
        if (tableSelectedItems?.length > 0) {
            await setSelectedItemCount(tableSelectedItems?.length);
            setShowDeleteModal(true);
        }
    };

    const handleClose = async (e) => {
        await setSelectedItemCount(tableSelectedItems?.length);
        setShowDeleteModal(false);
    };

    const deleteSuccess = (res) => {
        setAlert({
            show: true,
            message: "Site(s) deleted successfully",
        });
        setTableSelectedItems([]);
        setUpdateTable(!updateTable);
    };

    const deleteFail = (err) => {
        if (err?.redirect) {
            setCanRedirectToLogin(true);
        }
        setAlert({
            show: true,
            message: err?.data?.message
                ? err.data.message
                : "Site(s) deletion failed",
            type: "danger",
        });
        err?.message?.length && console.log(err);
    };

    const handleDelete = async (e) => {
        setShowDeleteModal(false);
        let tempTableData = tableData.filter((d) => {
            return tableSelectedItems.indexOf(d[0]) === -1;
        });
        setTableData(tempTableData);

        if (tempTableData.length === 0) {
          setRenderEmptyPage(true);
          setRenderDataTable(false);
        }
    
        Utils.deleteSites(tableSelectedItems).then(deleteSuccess, deleteFail);
    };

    let [addModalCanOpen, setAddModalCanOpen] = useState(false);

    const openAddModal = (e) => {
        e.preventDefault();
        setAddModalCanOpen(true);
    };


    const navgiatToAddPage = (e) => {
        e.preventDefault();
        navigate(Utils.APP_URLS.ADD_SITE_PAGE);
    };

    const navgiatToEditPage = (e) => {
        e.preventDefault();
        // console.log("event arraived:::", e.currentTarget);
        allSites.forEach((site, index) => {
            if (site.id === siteIdForEdit) {
                // let siteid = e.currentTarget.attributes.templateid.value;
                //console.log(templateid);
                navigate(
                    Utils.APP_URLS.EDIT_SITE_PAGE.replace(":siteid", siteIdForEdit))
                // targetUser = user;
                // setEditableUserIndex(index);
            }
        });
        // let templateid = e.currentTarget.attributes.templateid.value;
        // //console.log(templateid);
        // navigate(
        //     Utils.APP_URLS.EDIT_SITE_PAGE.replace(":siteid", templateid)
        // );
    };

    let [editModalCanOpen, setEditModalCanOpen] = useState(false);
    let [editableBrand, setEditableBrand] = useState({});
    let [editableBrandIndex, setEditableBrandIndex] = useState(-1);


    useEffect(() => { }, [editableBrand]);

    const closeAddModal = (e) => {
        setAddModalCanOpen(false);
    };

    const closeEditModal = (e) => {
        setEditModalCanOpen(false);
    };

    let [cloneModalCanOpen, setCloneModalCanOpen] = useState(false);
    let [moveModalCanOpen, setMoveModalCanOpen] = useState(false);

    const openMoveModal = (e) => {
        e.preventDefault();
        setMoveModalCanOpen(true);
    };

    const openCloneModal = (e) => {
        e.preventDefault();
        setCloneModalCanOpen(true);
    };

    const closeCloneModal = (e) => {
        setCloneModalCanOpen(false);
    };

    return (
        <div className="indi-body-cards-wrapper d-flex w-100">
            <div className="indi-add-card-title">
                Sites
                <div className="d-none1 w-50 indi-body-actions">
                    {(admin || superAdmin) && (
                        <div
                            className={`indi-body-action ${moveIconClass}`}
                            role="button"
                            onClick={openMoveModal}
                        >
                            <span className="indi-move-icon">
                              <ArrowsMove />
                            </span>
                            Move
                        </div>
                    )}
                    {(admin || superAdmin) && (
                        <div
                            className={`indi-body-action ${editIconClass}`}
                            role="button"
                            onClick={openCloneModal}
                        >
                            <img className="indi-w-20" src={AddIcon} alt="Edit-icon"></img>
                            Clone
                        </div>

                    )}
                    {((false && admin) || (false && superAdmin)) && (
                        <div
                            className="indi-body-action"
                            role="button"
                            onClick={navgiatToAddPage}
                        >
                            <img className="indi-w-20" src={AddIcon} alt="Edit-icon"></img>
                            Add
                        </div>
                    )}
                    <div
                        className={`indi-body-action ${editIconClass}`}
                        role="button"
                        onClick={navgiatToEditPage}
                    >
                        <img className="indi-w-20" src={EditIcon} alt="edit-icon"></img>
                        Edit
                    </div>

                    <div className={`indi-body-action ${moveIconClass}`} role="button" onClick={handleShow}>
                        <img className="indi-w-20" src={DeleteIcon} alt="Delete-icon"></img>
                        Delete
                    </div>
                </div>
            </div>
            {canRender && (
                <>
                    {renderDataTable && (
                        <DataTable
                            minRows={0}
                            tableProps={{
                                tableColumns,
                                tableColumnSchema,
                                tableData,
                                tableSelectedItems,
                                setTableSelectedItems,
                            }}
                        />
                    )}
                    {renderEmptyPage && (
                        <EmptyPage
                            props={{
                                emptyMessage: "No sites are available",
                            }}
                        />
                    )}
                </>
            )}

            <Modal centered show={showDeleteModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete confirmation?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure to delete select {selectedItemCount} item(s)?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        No
                    </Button>
                    <Button variant="primary" onClick={handleDelete}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
            {cloneModalCanOpen && (
                <CloneSitePage
                    props={{
                        cloneModalCanOpen,
                        setCloneModalCanOpen,
                        tableData,
                        setTableData,
                        tableSelectedItems,
                        setTableSelectedItems,
                        loadProjectSites: loadFreshSites,
                    }}
                />
            )}

            {moveModalCanOpen && (
                <MoveSitePage 
                props={{
                    moveModalCanOpen,
                    setMoveModalCanOpen,
                    tableData,
                    setTableData,
                    siteContent,
                    setSiteContent,
                    currentFolderId: projectid,
                    loadProjectSites: loadFreshSites,
                    tableSelectedItems,
                    setTableSelectedItems,
                }}
                />
            )}
        </div>
    );
};

export default Sitespage;